export const MAP_STYLE_STORAGE_KEY = 'dlv.maps.savedStyle.v1';

export const isValidMapStyle = (style) => {
  if (!style || typeof style !== 'object') return false;
  if (style.version !== 8) return false;
  if (!style.sources || typeof style.sources !== 'object') return false;
  if (!Array.isArray(style.layers)) return false;
  return true;
};

export const loadMapStyleFromStorage = () => {
  try {
    const raw = window.localStorage.getItem(MAP_STYLE_STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return isValidMapStyle(parsed) ? parsed : null;
  } catch (error) {
    return null;
  }
};

export const saveMapStyleObjectToStorage = (style) => {
  if (!isValidMapStyle(style)) return false;
  try {
    window.localStorage.setItem(MAP_STYLE_STORAGE_KEY, JSON.stringify(style));
    return true;
  } catch (error) {
    return false;
  }
};

export const saveMapStyleFromMapToStorage = (map) => {
  if (!map || typeof map.getStyle !== 'function') return false;
  return saveMapStyleObjectToStorage(map.getStyle());
};

export const clearStoredMapStyle = () => {
  try {
    window.localStorage.removeItem(MAP_STYLE_STORAGE_KEY);
  } catch (error) {
    // Ignore storage cleanup failures.
  }
};

export const downloadMapStyleJson = (style, filename = `tegola-style-${Date.now()}.json`) => {
  if (!isValidMapStyle(style)) return false;
  try {
    const blob = new Blob([JSON.stringify(style, null, 2)], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.download = filename;
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
    URL.revokeObjectURL(url);
    return true;
  } catch (error) {
    return false;
  }
};
